'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dhis = require('./dhis');

var _dhis2 = _interopRequireDefault(_dhis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noValidation = function noValidation(data) {
    return data;
};

exports.default = {
    dhis: _dhis2.default,
    noValidation: noValidation
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/store/validators/index.js
 ** module id = 221
 ** module chunks = 0 1
 **/